<template>
  <div class="panel-block is-block">
    <div class="is-flex is-justify-content-space-between is-align-items-center">
      <label :for="inputId" class="label has-text-weight-normal mb-0">
        <span class="icon-text is-align-items-center">
          <span>{{ label }}</span>
          <slot name="hint" />
        </span>
      </label>
      <div class="is-flex is-align-items-center">
        <span class="has-text-weight-normal mr-2">{{ displayValue }}</span>
        <button
          v-if="showReset"
          class="button is-warning is-small"
          title="Reset to default"
          @click="$emit('reset')"
        >
          <span class="icon is-small"><i class="fas fa-undo"></i></span>
        </button>
      </div>
    </div>
    <div class="control my-2">
      <input
        :id="inputId"
        type="range"
        class="slider is-fullwidth"
        :value="modelValue"
        :min="min"
        :max="max"
        :step="step"
        :data-test-id="testId"
        @input="handleInput"
        @change="handleChange"
      />
    </div>
    <slot name="footer" />
  </div>
</template>

<script setup>
  import { computed, inject } from "vue";

  const props = defineProps({
    modelValue: { type: Number, required: true },
    label: { type: String, required: true },
    displayValue: { type: String, required: true },
    min: { type: Number, required: true },
    max: { type: Number, required: true },
    step: { type: Number, default: 1 },
    defaultValue: { type: Number, required: true },
    testId: { type: String, default: "" },
    parseAs: { type: String, default: "int" },
    inputId: { type: String, default: "" },
  });

  const emit = defineEmits(["update:modelValue", "reset"]);
  const triggerSave = inject("triggerSave");

  const showReset = computed(() => props.modelValue !== props.defaultValue);

  function handleInput(event) {
    const value =
      props.parseAs === "float" ? parseFloat(event.target.value) : parseInt(event.target.value, 10);
    emit("update:modelValue", value);
  }

  function handleChange() {
    triggerSave?.();
  }
</script>

<style lang="scss" scoped>
  input[type="range"].slider {
    -webkit-appearance: none;
    width: 100%;
    height: 0.8em;
    border-radius: 4px;
    background: #eeeeee;
    border: 1px solid #dddddd;
    outline: none;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      width: 1.2em;
      height: 1.2em;
      border-radius: 4px;
      background: #f6f6f6;
      border: 1px solid #cccccc;
      cursor: default;
      /* Center thumb over 0.8em track; slight extra push down (+2px) to visually balance */
      margin-top: calc((0.8em - 1.2em) / 2 + 2px);
      position: relative;
      z-index: 2;
    }

    &::-moz-range-thumb {
      width: 1.2em;
      height: 1.2em;
      border-radius: 4px;
      background: #f6f6f6;
      border: 1px solid #cccccc;
      cursor: default;
    }

    /* Firefox track */
    &::-moz-range-track {
      width: 100%;
      height: 0.8em;
      background: #eeeeee;
      border-radius: 4px;
      border: 1px solid #dddddd;
    }
  }
</style>
